import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { useSideNav } from '../../hooks/useSideNav'
import Icon from '../icon'

const SideBar: React.FC<{
  navOpen?: boolean
  setNavOpen?: (val: boolean) => void
}> = ({ navOpen, setNavOpen }) => {
  const { pathname } = useLocation()

  const { navItems, subMenuOpen, setSubMenuOpen } = useSideNav()

  return (
    <div
      className={`
      bg-frost
      h-full
      border-r-divider-gray border-r
      px-4 md:px-10 py-4 md:py-10
      overflow-y-scroll
      hide-scroll-bar
      flex flex-col
      w-full max-w-[320px]
      absolute xl:relative
      right-[100%] xl:right-auto ${navOpen && '!left-0'}
      !z-[998]
      `}
    >
      {/* Main  */}
      <div className="text-base">
        <div className="flex flex-col text-pry-gray">
          {navItems
            .filter((i) => !i.hidden)
            .map(({ href, text, icon, subMenu, notificationElement }, idx) => (
              <div key={idx}>
                <NavLink
                  to={href}
                  onClick={(e) => {
                    if (subMenu.length > 0) {
                      e.preventDefault()
                      setSubMenuOpen({
                        state: !subMenuOpen.state,
                        index: idx,
                      })
                    } else {
                      setNavOpen?.(false)
                    }
                  }}
                >
                  {({ isActive }) => {
                    const isSubMenuActive = subMenu.some(({ href }) =>
                      pathname.includes(href),
                    )
                    return (
                      <div
                        className={`
                          flex items-center gap-4 p-4 font-normal
                          ${
                            (isActive && subMenu.length === 0) ||
                            (isSubMenuActive && subMenu.length > 0)
                              ? 'text-primary bg-primary/5 !font-semibold'
                              : ''
                          }
                          rounded-[8px] hover:text-primary 
                          transition-all duration-500
                          `}
                      >
                        <Icon id={icon} width={24} height={24} />

                        <div className="flex-1">{text}</div>

                        {notificationElement}

                        {subMenu.length > 0 && (
                          <Icon
                            id="left-caret"
                            width={18}
                            height={12}
                            className={`transition-all duration-300 ${
                              subMenuOpen.state && subMenuOpen.index === idx
                                ? 'rotate-90'
                                : '-rotate-90'
                            }`}
                          />
                        )}
                      </div>
                    )
                  }}
                </NavLink>

                {subMenuOpen.state && subMenuOpen.index === idx ? (
                  <div className="flex flex-col pl-[50px] pr-4">
                    {subMenu
                      .filter((i) => !i.hidden)
                      .map(({ href, title }, idx) => {
                        const key = `${title}-subMenu-${idx}`
                        return (
                          <NavLink
                            to={href}
                            key={key}
                            end={subMenu.some(
                              ({ href: siblingHref }) =>
                                siblingHref !== href &&
                                siblingHref.startsWith(`${href}/`),
                            )}
                            className={`py-4 hover:text-primary transition-all duration-300`}
                            onClick={() => {
                              setNavOpen?.(false)
                            }}
                          >
                            {({ isActive }) => (
                              <span className={`${isActive && 'text-primary'}`}>
                                {title}
                              </span>
                            )}
                          </NavLink>
                        )
                      })}
                  </div>
                ) : undefined}
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default SideBar
